import React from 'react';
export const Calendar = () => (
  <svg width="117px" height="91px" viewBox="0 0 117 91" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1326.000000, -1501.000000)">
        <g transform="translate(1327.000000, 1501.000000)">
          <path
            d="M102.6836,25.5209 L102.5846,26.8329"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M102.3853,29.4565 L102.2863,30.7685"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M105.1084,28.3442 L103.7964,28.2442"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M101.1729,28.0453 L99.8609,27.9463"
            stroke="#AA81F7"
            strokeLinecap="round"
          />
          <path
            d="M27.5132,51.4633 L27.4132,52.7753"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M27.2148,55.3998 L27.1148,56.7118"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M29.938,54.2865 L28.626,54.1865"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M26.0024,53.9877 L24.6904,53.8887"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M109.0815,37.9652 C109.0445,38.4452 108.6255,38.8072 108.1445,38.7702 C107.6625,38.7342 107.3025,38.3142 107.3385,37.8322 C107.3745,37.3522 107.7945,36.9902 108.2755,37.0282 C108.7575,37.0642 109.1175,37.4842 109.0815,37.9652"
            fill="#5EDAB0"
          />
          <polyline
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="39.6528 29.184 40.8258 13.709 92.9938 17.663 89.9198 58.235 37.7518 54.282 39.1468 35.865"
          />
          <polygon
            fill="#ED0722"
            points="92.3008 26.81 40.1328 22.858 40.8258 13.709 92.9938 17.663"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="92.3008 26.81 40.1328 22.858 40.8258 13.709 92.9938 17.663"
          />
          <polygon
            fill="#FFFFFF"
            points="53.6685 18.9867 50.0785 18.7147 50.7785 9.4737 54.3685 9.7457"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="53.6685 18.9867 50.0785 18.7147 50.7785 9.4737 54.3685 9.7457"
          />
          <polygon
            fill="#FFFFFF"
            points="83.7114 21.2631 80.1224 20.9911 80.8224 11.7501 84.4114 12.0221"
          />
          <polygon
            stroke="#7350A0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="83.7114 21.2631 80.1224 20.9911 80.8224 11.7501 84.4114 12.0221"
          />
          <path d="M45.2979,37.9623 L85.3949,41.0003" stroke="#E2E8EE" />
          <path d="M50.166,30.4262 L54.226,35.1532" stroke="#E2E8EE" />
          <path d="M54.5591,30.7592 L49.8331,34.8202" stroke="#E2E8EE" />
          <path d="M64.6138,31.5209 L68.6748,36.2479" stroke="#E2E8EE" />
          <path d="M69.0073,31.8539 L64.2813,35.9149" stroke="#E2E8EE" />
          <path d="M59.1914,28.644 L57.5804,49.908" stroke="#E2E8EE" />
          <path d="M74.0269,29.768 L72.4159,51.032" stroke="#E2E8EE" />
          <polygon
            fill="#FFFFFF"
            points="79.9121 43.5414 80.8571 45.8884 83.3261 46.4394 81.3861 48.0634 81.6241 50.5824 79.4801 49.2394 77.1591 50.2434 77.7731 47.7904 76.1001 45.8934 78.6241 45.7194"
          />
          <polygon
            stroke="#5EDAB0"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="79.9121 43.5414 80.8571 45.8884 83.3261 46.4394 81.3861 48.0634 81.6241 50.5824 79.4801 49.2394 77.1591 50.2434 77.7731 47.7904 76.1001 45.8934 78.6241 45.7194"
          />
          <polyline
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="33.7075 36.1625 25.3465 30.1125 22.0645 6.5595 63.3845 0.8415 65.1495 13.7155"
          />
          <path
            d="M57.0103,8.6547 L60.1083,8.2187"
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M29.2822,12.5453 L47.7122,9.9593"
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#C3D3D8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="25.3462 30.1127 32.7272 28.9797 33.7072 36.1627"
          />
          <path
            d="M114.8662,86.0805 L83.1212,86.0805"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M37.2041,86.0805 L18.4481,86.0805"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.4482,86.0805 L0.4112,86.0805"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M79.8496,86.1908 C79.8496,88.5008 72.1826,90.3728 62.7236,90.3728 C53.2646,90.3728 45.5976,88.5008 45.5976,86.1908 C45.5976,83.8798 53.2646,82.0078 62.7236,82.0078 C72.1826,82.0078 79.8496,83.8798 79.8496,86.1908"
            fill="#D0D7DA"
          />
        </g>
      </g>
    </g>
  </svg>
);
